import { useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";

// Contexts
import { VideoPlayerSettingsContext } from "../../../../../Context/VideoPlayerSettingsContext";

// Models
import SeriesDTO from "../../../../../Models/DTOs/SeriesDTO";

// Hooks
import useFetchSeriesDetails from "../../../../../Hooks/Content/Watch/Series/useFetchSeriesDetails";

// Components
import VideoPlayer from "../../../../../Components/Layouts/Content/Watch/VideoSingle/VideoPlayer/VideoPlayer";
import ButtonPill from "../../../../../Components/Buttons/ButtonPill";

// Constants
import {RoutePaths} from "../../../../../Constants/RoutePaths";

const TrailerSeries = () => {
    // Parse the URL param into a number.
    const
        { id } = useParams<string>(),
        seriesId = id ? parseInt(id) : undefined,

        // Context
        { isTheatreMode, setIsTheatreMode } = useContext(VideoPlayerSettingsContext),

        // Series object state
        [seriesData, setSeriesData] = useState<SeriesDTO>({} as SeriesDTO),

        // Fetch series details (using refresh value 0 for now)
        { series, loading, error } = useFetchSeriesDetails(seriesId, 0);

    useEffect(() => {
        if (series) {
            // Update the series data if it's new
            if (seriesData.Id === undefined || series.Id !== seriesData.Id) {
                setSeriesData(series);
            }
        }
    }, [series]);

    return (
        <div className="page--watch-video page--watch-trailer">
            <div className={`page__wrapper ${isTheatreMode ? 'is-theatre-mode' : 'is-not-theatre-mode'}`}>
                <VideoPlayer
                    key={seriesData.Id}
                    src={seriesData.TrailerLink ?? undefined}
                    autoPlay={true}
                    playbackAllowed={true}
                    isTheatreMode={isTheatreMode}
                    setIsTheatreMode={setIsTheatreMode}
                    isCommentInputFocused={false}
                    useTrailerLink={true}
                />

                <div className="watch-video__primary-info watch-trailer__primary-info">
                    <div className="primary-info__top-row">
                        <div className="primary-info__title-and-date">
                            <h1 className={loading ? "loader--side-to-side" : "is-loaded"}>
                                {!loading && series.Title} Trailer
                            </h1>
                        </div>

                    </div>
                </div>


                {seriesId && (
                    <div className="watch__button">
                        <ButtonPill
                            label="View Series"
                            className=""
                            link={RoutePaths.SeriesEpisodes(seriesId)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default TrailerSeries;
